import { useMemo } from 'react';
import { useProperty } from '@vibesites/runtime/react';
import { resolveBedroomOptionsLabel } from '../utils/bedroomOptions';

/**
 * Property object with `property_bedrooms_range` rewritten to a discrete
 * bedroom list (e.g. "2-2" → "2", "1-3" → "1, 2 & 3"), preferring distinct
 * bed counts from floor plans. Use when resolving richtext field tokens so
 * every `property_bedrooms_range` chip on the site shows the same label.
 */
export function usePropertyWithBedroomOptions(): Record<string, unknown> {
  const property = useProperty();

  return useMemo(() => {
    const label = resolveBedroomOptionsLabel(
      property.floorplans,
      property.property_bedrooms_range as string | null | undefined,
    );
    if (!label) return property as Record<string, unknown>;
    return {
      ...(property as Record<string, unknown>),
      property_bedrooms_range: label,
    };
  }, [property]);
}
